import  styled  from 'styled-components'

export const DashHeader = styled.div`
    padding: 20px 20px 0;

    h4 {
        font-weight: 600;
        text-align: left;
        font-size: 16px;
    }

    p {
        margin: 0;
    }
`


// WEBPACK FOOTER //
// ./src/components/styled_components/dash_header.js